import {
  VIDEO_CALL_COMPLETE_REASON,
  type CreateVideoCallApiResponse,
  type SendVideoCallLogsApiQuery,
  type VideoCallRoom,
  type VideoCallRatingQuery,
} from "@/Modules/Models/Api/VideoCalls";

import { get2, patch2, post2, remove2 } from "./utils/FunctionalTherapyApi";

interface HangDownQuery {
  completed_reason?: VIDEO_CALL_COMPLETE_REASON;
}

export const getPatientRoomsInProgress = async (): Promise<VideoCallRoom[]> => {
  return get2<void, VideoCallRoom[]>(`/v2.0/video_calls/rooms`);
};

export const createRoom = async (chatId: string): Promise<CreateVideoCallApiResponse> => {
  return post2<{ chat_id: string }, CreateVideoCallApiResponse>(`/v2.0/video_calls/token`, {
    chat_id: chatId,
  });
};

export const hangUp = async (roomId: string): Promise<void> => {
  return patch2<void, void>(`/v2.0/video_calls/rooms/${roomId}`);
};

export const hangDown = async (
  roomId: string,
  reason: VIDEO_CALL_COMPLETE_REASON = VIDEO_CALL_COMPLETE_REASON.OK
): Promise<void> => {
  return remove2<HangDownQuery, void>(`/v2.0/video_calls/rooms/${roomId}`, {
    completed_reason: reason,
  });
};

export const sendAudio = (roomId: string, audio: Blob): Promise<unknown> => {
  const formData = new FormData();

  formData.append("audio", audio);

  return post2<FormData, unknown>(`/v1.0/video_calls/rooms/${roomId}/audio`, formData);
};

export const sendRating = (roomId: string, rating: VideoCallRatingQuery): Promise<unknown> => {
  return post2<VideoCallRatingQuery, unknown>(`/v2.0/video_calls/rooms/${roomId}/rating`, rating);
};

export const sendLogs = (sendLogsApiQuery: SendVideoCallLogsApiQuery): Promise<void> => {
  return post2<SendVideoCallLogsApiQuery, void>("/v1.0/logs/video_calls", sendLogsApiQuery);
};
